export const SPEED = 25
export const FACEBOOK = 'https://www.facebook.com/william.belcher.984'
export const GITHUB = 'https://github.com/Belchy06'
export const LINKEDIN = 'https://www.linkedin.com/in/william-belcher' 
export const YOUTUBE = 'https://www.youtube.com/channel/UCv6ZaZnHCoMfuSKWwD4nYSQ'
